import { Link } from "react-router-dom";

export default function PrivacyPolicy() {
    return (
        <div
            style={{
                height: "100%",
                overflowY: "auto",
                WebkitOverflowScrolling: "touch",
                display: "flex",
                flexDirection: "column",
            }}
        >
            <header
                style={{
                    position: "sticky",
                    top: 0,
                    width: "100%",
                    display: "flex",
                    zIndex: 1000,
                    color: "black",
                    fontFamily: "'Quicksand', sans-serif",
                    boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
                }}
            >
                <div style={{ display: "flex", flexDirection: "row", padding: "1% 1% 1% 1%", justifyContent: "space-between", backgroundColor: "#3d5a5a", width: "100%" }}>
                    <Link to="/" style={{ display: "flex", textDecoration: "none" }}>
                        <h1 style={{ color: "#a8d8d8" }}>Mem</h1>
                        <h1 style={{ color: "#d4e8e8" }}>Case</h1>
                    </Link>
                </div>
            </header>

            <main
                style={{
                    backgroundColor: "#7a9a9a",
                    padding: "2rem 10% 6rem",
                    fontFamily: "'Quicksand', sans-serif",
                    color: "#f4f8f8",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "2rem",
                    flexGrow: 1,
                }}
            >
                <section style={{ width: "100%", maxWidth: "600px" }}>
                    <h1 style={{ fontSize: "2rem", fontWeight: "bold", marginBottom: "1rem" }}>
                        Privacy Policy
                    </h1>

                    <p>
                        At <strong>MemCase</strong>, your privacy is important to us. Here’s how we handle your data:
                    </p>

                    <ul style={{ paddingLeft: "1rem", marginTop: "1rem", lineHeight: 1.5 }}>
                        <li>
                            We only retain data related to your order itself. This includes order details necessary to create and fulfill your phone case.
                        </li>
                        <li>
                            Your images are used only to create your phone case template. Once your order is successfully completed, this data is stored for no longer than 90 days and then deleted.
                        </li>
                        <li>
                            We use <a href="https://printify.com/privacy-policy/" target="_blank" rel="noopener noreferrer" style={{ color: "#d4f0f0", textDecoration: "underline" }}>Printify</a> to fulfill orders. Please refer to their privacy policy to understand how they handle your order data.
                        </li>
                        <li>
                            You may receive minimal email updates regarding your order and promotions. You can unsubscribe at any time.
                        </li>
                    </ul>

                    <p style={{ marginTop: "2rem" }}>
                        If you have any questions about our privacy practices, please contact us at <strong>MemCaseAssist@gmail.com</strong>.
                    </p>
                </section>

                <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", gap: "10%", width: "100%" }}>
                    <Link to='/termsandconditions' style={{ textDecoration: "none", color: "#d4f0f0" }}>
                        Terms And Conditions
                    </Link>
                </div>

                <Link to="/" style={{ textDecoration: "none", width: "100%", display: "flex", justifyContent: "center", marginTop: "1rem" }}>
                    <button style={{
                        padding: "0.75rem 2rem",
                        fontSize: "1rem",
                        backgroundColor: "#6b9e9e",
                        color: "#ffffff",
                        border: "2px solid #3d5a5a",
                        borderRadius: "10px",
                        cursor: "pointer",
                        fontFamily: "'Quicksand', sans-serif",
                    }}>
                        Home
                    </button>
                </Link>

                <div style={{ display: "flex", flexDirection: "column", gap: "2%", alignItems: "center", justifyContent: "center", marginTop: "1rem" }}>
                    <div>© [2025] [MemCase]. All Rights Reserved.</div>
                </div>
            </main>
        </div>
    );
}
